/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SkillResponse
 */
export interface SkillResponse {
    /**
     * 
     * @type {string}
     * @memberof SkillResponse
     */
    label: string;
    /**
     * 
     * @type {boolean}
     * @memberof SkillResponse
     */
    certified: boolean;
    /**
     * 
     * @type {string}
     * @memberof SkillResponse
     */
    level: SkillResponseLevelEnum;
}


/**
 * @export
 */
export const SkillResponseLevelEnum = {
    None: 'NONE',
    Beginner: 'BEGINNER',
    Intermediate: 'INTERMEDIATE',
    Advanced: 'ADVANCED'
} as const;
export type SkillResponseLevelEnum = typeof SkillResponseLevelEnum[keyof typeof SkillResponseLevelEnum];


/**
 * Check if a given object implements the SkillResponse interface.
 */
export function instanceOfSkillResponse(value: object): value is SkillResponse {
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('certified' in value) || value['certified'] === undefined) return false;
    if (!('level' in value) || value['level'] === undefined) return false;
    return true;
}

export function SkillResponseFromJSON(json: any): SkillResponse {
    return SkillResponseFromJSONTyped(json, false);
}

export function SkillResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SkillResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'],
        'certified': json['certified'],
        'level': json['level'],
    };
}

export function SkillResponseToJSON(value?: SkillResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'label': value['label'],
        'certified': value['certified'],
        'level': value['level'],
    };
}

